export const WEB_SETTINGS_PANELS = [
  "root",
  "investorProfile",
  "brokerages",
  "brokerageConnect",
  "account",
  "notifications",
  "manualHoldings",
  "subscription",
  "usage",
  "referrals",
  "deleteAccount",
] as const;

export type T_WebSettingsPanel = (typeof WEB_SETTINGS_PANELS)[number];
export type T_WebSettingsAccountUpdate = "email" | "password";
